const CampaignStatuses = {
    DRAFT: 'DRAFT',
    PROCESSING: 'PROCESSING',
    SENT: 'SENT',
    SCHEDULED: 'SCHEDULED',
    DELETED: 'DELETED',
    FAILED: 'FAILED'
  };
  
  export default CampaignStatuses;